import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { NgxPaginationModule } from 'ngx-pagination';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SubscribeModule } from './footer/subscribe/subscribe.module';
import { HotelModule } from './hotel/hotel.module';
import { LoginComponent } from './login/login.component';
import { MenuComponent } from './menu/menu.component';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    MenuComponent,

    // GenericTableComponent,
    // SearchFilterPipe,
    // SortTablePipe,   

  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  exports: [],

  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TypeaheadModule.forRoot(),
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    CommonModule,
    NgxPaginationModule,
    FormsModule,
    HotelModule,
    ToastrModule.forRoot(),
    ReactiveFormsModule,
    SubscribeModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
